import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from "@angular/router";
import { Observable, filter, map, switchMap } from "rxjs";
import { FooterComponent } from "../footer/footer.component";
import { NavigationComponent } from "../navigation/navigation.component";
import { BannerModalComponent } from "../../ui/modal/banner-modal.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dev-portal-base-layout",

  imports: [CommonModule, RouterModule, NavigationComponent, FooterComponent, BannerModalComponent],
  template: `
    <dev-portal-navigation [basicNavigation]="(basicNavigation$ | async) || false"></dev-portal-navigation>
    <dev-portal-banner-modal />

    <div class="flex-1" id="pageContent">
      <router-outlet></router-outlet>
    </div>

    <dev-portal-footer></dev-portal-footer>
  `,
  styles: [
    `
      :host {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    `
  ]
})
export default class BaseLayoutComponent {
  public router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  basicNavigation$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => this.activatedRoute),
    map((route) => {
      let mappedRoute = route;
      while (mappedRoute.firstChild) {
        mappedRoute = mappedRoute.firstChild;
      }
      return mappedRoute;
    }),
    switchMap((route) => route.data),
    map((data) => data["basicNavigation"] || false)
  );
}
